export const TmsActionTypes = {
  TMS_LIST_LOADING: "TMS_S/TMS_LIST_LOADING",
  TMS_LIST_SUCCESS: "TMS_S/TMS_LIST_SUCCESS",
  TMS_LIST_FAIL: "TMS_S/TMS_LIST_FAIL",

  TMS_MULTIPLE_LOADING: "TMS_S/TMS_MULTIPLE_LOADING",
  TMS_MULTIPLE_SUCCESS: "TMS_S/TMS_MULTIPLE_SUCCESS",
  TMS_MULTIPLE_FAIL: "TMS_S/TMS_MULTIPLE_FAIL",
};
